

export const rawText = (content, symble, symble2) => {
    if (!content) return
    const pattern = new RegExp(symble, 'g')
    const pattern2 = new RegExp(symble2, 'g')
    return content.replace(pattern, '').replace(pattern2, '')
}

export const filteredContent = (content) => content.replace(/<span[^>]*>(.*?)<\/span>/g, '$1');

export const formattedContent = (content, symble, symble2) => {
    if (!content) return
    const pattern = new RegExp(symble + '(.*?)' + symble, 'g')
    const pattern2 = new RegExp(symble2 + '(.*?)' + symble2, 'g')
    return content.replace(pattern, (match, p1) => {
        return `<span class="hidden">${symble}</span><span class="main-highlight">${p1}</span><span class="hidden">${symble}</span>`
    }).replace(pattern2, (match, p1) => {
        return `<span class="hidden">${symble2}</span><span class="todo-highlight">${p1}</span><span class="hidden">${symble2}</span>`
    })
}

export const convertTimeToSeconds = (time) => {
    const parts = time.split(':').map(Number);
    if (parts.length === 2) {
        // 格式为 mm:ss
        return parts[0] * 60 + parts[1];
    } else if (parts.length === 3) {
        // 格式为 hh:mm:ss
        return parts[0] * 3600 + parts[1] * 60 + parts[2];
    }
    return 0; // 如果格式不正确，返回0
};

export const getFormattedDate =()=> {
    const date = new Date();

    const year = date.getFullYear(); // 获取年份
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 获取月份（补零）
    const day = String(date.getDate()).padStart(2, '0'); // 获取日期（补零）
    const hours = String(date.getHours()).padStart(2, '0'); // 获取小时（补零）
    const minutes = String(date.getMinutes()).padStart(2, '0'); // 获取分钟（补零）

    return `${year}年${month}月${day}日 ${hours}:${minutes}`;
}